import { GENERAL_EMPLOYER, GENERAL_FUTURE_EXPENSES_TABLE, RESET_GENERAL, GENERAL_EMPLOYER_NEW, } from "./types";
const initialState = {
    employer: {
        employer_list: [],
        funds: [],
        value: "",
        visible: false,
        showFunds: false,
        employer_selected: false,
        funds_load: false,
        search_loading: false,
    },
    futureExpenses: {
        total: null,
        listData: null,
        currentTotal: null,
        futureTotal: null,
        graphData: null,
        inflation: 2,
    },
    employerNew: {
        funds: [],
        employer_selected: "",
        selected_ein: null,
    },
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_EMPLOYER:
            return {
                ...state,
                employer: {
                    ...state.employer,
                    ...action.payload,
                },
            };
        case GENERAL_FUTURE_EXPENSES_TABLE:
            return {
                ...state,
                futureExpenses: {
                    ...state.futureExpenses,
                    ...action.payload,
                },
            };
        case GENERAL_EMPLOYER_NEW:
            return {
                ...state,
                employerNew: {
                    ...state.employerNew,
                    ...action.payload,
                },
            };
        case RESET_GENERAL:
            return {
                ...initialState,
                employer: {
                    ...initialState.employer,
                    employer_list: [],
                    funds: [],
                },
                futureExpenses: {
                    ...initialState.futureExpenses,
                },
                employerNew: {
                    ...initialState.employerNew,
                },
            };
        default:
            return state;
    }
};
